import { Navigate, useParams } from 'react-router';

import { base64ToGuid, tryParseGuid } from '@ngsos/portal-core/incidents';
import { IncidentDetailPage } from './IncidentDetailPage';
import { IncidentNotFoundPage } from './IncidentNotFoundPage';

export function IncidentDetailRoute() {
  const { incidentId } = useParams<'incidentId'>();

  if (incidentId === undefined) {
    return <IncidentNotFoundPage />;
  }

  const parsedGuid = tryParseGuid(incidentId);
  if (parsedGuid !== null) {
    return <IncidentDetailPage key={parsedGuid} incidentId={parsedGuid} />;
  }

  let redirectTarget: string;
  try {
    redirectTarget = base64ToGuid(incidentId);
  } catch {
    return <IncidentNotFoundPage />;
  }

  return <Navigate to={`/incident/${redirectTarget}`} />;
}
